import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { LogOut } from 'lucide-react';
import { useUser } from '@/hooks/user-user';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Settings } from 'lucide-react';
import StyledButton from '../StyledHtmlElements/Button';
import { useTheme } from '@/hooks/use-Theme';
import { Theme } from '../Theme/ThemeContext';
import { useNavigate } from 'react-router-dom';

const AccountSettings = () => {
  const { signOut } = useUser();
  const { theme, setTheme } = useTheme();
  const navigate = useNavigate();

  const signOutAndRedirect = () => {
    signOut();
    navigate('/');
  };

  return (
    <Popover>
      <PopoverTrigger>
        <Settings size={'1rem'} />
      </PopoverTrigger>
      <PopoverContent>
        <div className="flex flex-col gap-2">
          <h2 className="font-normal text-lg mb-3 text-foreground">Benutzer Einstellungen</h2>

          <div className="flex gap-2 items-center justify-between">
            <h3 className="font-thin text-base !text-foreground">Design:</h3>

            <Tabs defaultValue="account" className="w-fit text-xs bg-transparent" value={theme}>
              <TabsList className="">
                <TabsTrigger
                  className="data-[state=active]:bg-secondaryColor text-xs dark:data-[state=active]:bg-secondaryColor/40"
                  value={'light' satisfies Theme}
                  onClick={() => setTheme('light')}>
                  hell
                </TabsTrigger>
                <TabsTrigger
                  className="data-[state=active]:bg-secondaryColor text-xs dark:data-[state=active]:bg-secondaryColor/40"
                  value={'dark' satisfies Theme}
                  onClick={() => setTheme('dark')}>
                  dunkel
                </TabsTrigger>
                <TabsTrigger
                  className="data-[state=active]:bg-secondaryColor text-xs dark:data-[state=active]:bg-secondaryColor/40"
                  value={'system' satisfies Theme}
                  onClick={() => setTheme('system')}>
                  system
                </TabsTrigger>
              </TabsList>
            </Tabs>
          </div>
          <StyledButton className="m-auto mt-8 " variant={'default'} onClick={signOutAndRedirect}>
            Abmelden <LogOut />
          </StyledButton>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default AccountSettings;
